import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function JumboLoanPage() {
  return (
    <LoanProgramTemplate
      title="Jumbo Loans"
      subtitle="Our Loan Programs"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1777907381/Jumbo_izksu2.png"
      descriptionBold="Jumbo loans"
      description="offer financing for higher priced properties that exceed conforming loan limits, providing expanded borrowing power with tailored qualification standards."
      whyBuyersConsider="Jumbo loans allow buyers to finance high value homes with a single mortgage, offering competitive terms for those purchasing in more expensive markets."
      eligibilityItems={[
        'Loan amount must exceed conforming limits',
        'Higher minimum credit scores are required',
        'Larger down payments are typically needed',
        'Standard debt to income limits apply',
        'Cash reserve requirements may be needed',
      ]}
      benefitsItems={[
        'Ability to finance luxury or high-value properties',
        'Competitive Jumbo interest rate options',
        'Various fixed and adjustable-rate structures available',
        'Works with multiple property types depending on lender guidelines',
      ]}
    />
  );
}
